import CompanyProfileView from "@/views/company/profile/CompanyProfileView";

export default [
  {
    name: "pages.company.profile",
    path: "profile",
    component: CompanyProfileView
  },
  
  
];
